import moment from 'moment-timezone';
const errorOverlap = 'Business hours cannot overlap';
const errorEndTime = 'Opening hours must have an end time';
export function getRegExpMatchArrayFromTimeInterval(time) {
    return time.match(/[0-9]+/g);
}
export function getIntegerFromTimeInterval(time) {
    return time
        ? parseInt(getRegExpMatchArrayFromTimeInterval(time).join(''))
        : 0;
}
export function isValidISOString(isoString) {
    return moment(isoString, moment.ISO_8601).isValid();
}
/** Compare two given time intervals array to each other. */
function isOverlap([start, end], [open, close]) {
    return ((start >= open && start <= close) ||
        (end >= open && end <= close) ||
        (start <= open && end >= close));
}
/**
 * Compare a given time interval (start, end) to a set of intervals, to check if
 * it overlaps with any of them.
 */
function isInvalid({ start, end, index, intervals }) {
    return intervals === null || intervals === void 0 ? void 0 : intervals.some(({ start: open, end: close }, intervalIndex) => {
        if (intervalIndex === index)
            return false;
        const openInt = getIntegerFromTimeInterval(open);
        const closeInt = getIntegerFromTimeInterval(close);
        return isOverlap([start, end], [openInt, closeInt]);
    });
}
/** Validate the current list of intervals and return a new list of field errors. */
export function validateIntervals({ dayIndex, errors: currentErrors, intervals, }) {
    const newErrors = [...currentErrors];
    newErrors[dayIndex] = newErrors[dayIndex] || [];
    newErrors[dayIndex].length = (intervals === null || intervals === void 0 ? void 0 : intervals.length) || 0;
    newErrors[dayIndex] =
        (intervals === null || intervals === void 0 ? void 0 : intervals.map(({ start, end }, intervalIndex) => {
            if (!end)
                return errorEndTime;
            return isInvalid({
                start: getIntegerFromTimeInterval(start),
                end: getIntegerFromTimeInterval(end),
                index: intervalIndex,
                intervals,
            }) && intervalIndex > 0
                ? errorOverlap
                : '';
        })) || [];
    return newErrors;
}
